import { jsx } from 'react/jsx-runtime';
import { useTabs } from './use-tabs.js';
import s from './Tabs.module.scss.js';
var TabPanel = function TabPanel(_ref) {
  var value = _ref.value,
    children = _ref.children;
  var _useTabs = useTabs(),
    activeTab = _useTabs.activeTab;
  return activeTab === value ? /* @__PURE__ */jsx("div", {
    className: s.tabs__panel,
    children: children
  }) : null;
};
export { TabPanel };